const styles = theme => ({
    boxStyle: {
        position: "absolute",
        top: "49%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "1000px",
        maxHeight : "90vh",
        outline: "none",
        background: "#ffffff",
        padding: "24px",
        borderRadius: "15px",
        justifyContent: "center",
        alignItems: "center",
        "overflow-y" : "auto",
    },

    header:{
        display:'flex !important',
        flexDirection:'row !important',
        alignItems:'end !important',
        justifyContent: 'space-between !important'
    },

    heading:{
        fontSize : '20px !important',
        fontFamily: 'cardiuma-Bold  ! important',
        paddingLeft:'20px !important',
    },

    headingEdit:{
        fontSize : '20px !important',
        fontFamily: 'cardiuma-Bold  ! important',
        paddingLeft:'29px !important',
    },

    mainGrid:{
        display:'flex !important',
        flexDirection:'row !important',
        padding:' 10px 20px 5px 20px !important'
    },

    mainGridEdit:{
        display:'flex !important',
        flexDirection:'column !important',
        padding:' 10px 20px 0px 20px !important'
    },

    detailsHeading:{
        fontSize:'15px !important',
        fontFamily: 'cardiuma-M  ! important',
        color:'#050505 !important',
        marginBottom:'5px !important'
    },

    subGrid:{
        paddingLeft:'60px !important'
    },

    deatilsInfo:{
        fontSize:'15px !important',
        fontFamily: 'cardiuma-regular  ! important',
        marginBottom:'5px !important'
    },

    textfeild:{
        width:'30% !important',
        display:'flex !important',
        flexDirection:'column !important'
    },

    textFeildGrid:{
        width:'100% !important',
        display:'flex !important',
        justifyContent: 'space-between',
        margin:'10px'
    },
    textFeild2:{
        width:'37% !important'
    },
    
    button:{
        width: "100px !important",
        fontFamily: "cardiuma-M !important",
        fontSize: "14px !important",
        padding:'10px 20px 10px 20px !important',
        backgroundColor:'#f3d45e !important',
        color: "#000000 !important",
    },

    disabledButton : {
        width: "100px !important",
        fontFamily: "cardiuma-M !important",
        fontSize: "14px !important",
        padding:'10px 20px 10px 20px !important',
        backgroundColor:'#999999 !important',
        color: "#ffffff !important",
    },

    buttonGrid:{
        display:'flex !important',
        justifyContent:'center !important'
    },

    alertbox : {
        display:'flex !important', 
        justifyContent:'center !important', 
        marginTop:'20px !important'
    },

    dialogTitle :{ 
        textAlign:'center !important', 
        paddingTop:'0px !important', 
        paddingBottom:'10px !important'
    },

    dialogContentText : {
        textAlign:'center !important', 
        padding:'0px 20px 10px 20px !important'
    },

    dialogAction : {
        display:'flex !important', 
        justifyContent:'center !important'
    },
})

export default styles